import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=4e84f94d"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=4e84f94d&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e84f94d')) {
      api.createRecord('4e84f94d', component.options)
    } else {
      api.reload('4e84f94d', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=4e84f94d", function () {
      api.rerender('4e84f94d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/FileUpload.vue"
export default component.exports